import React, { useState } from "react";
import {ProductOptionStepsContext} from "./ProductOptionStepsProvider";
import Verspreiddatum from "../Components/ProductOptions/Steps/Verspreiddatum";

export const VerspreidenContext = React.createContext();

const VerspreidenProvider = props => {

    const [verspreidDatums, setVerspreidDatums] = useState(false);

    const onVerspreidDatums = date => {
        setVerspreidDatums(date);
    }

    const value = {
        onVerspreidDatums,
        verspreidDatums
    }
    return (
        <VerspreidenContext.Provider value={value}>
            {props.children}
        </VerspreidenContext.Provider>
    );
};
export default VerspreidenProvider;
